module.exports = __webpack_public_path__ + "img/logo-xs.645f4cdf.png";